import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from "@mui/material";
import GiftcardRow from "./giftcardsRow";
export default function GiftcardsTable({ giftcards, refresh, store }) {
  return (
    <TableContainer
      style={{ overflowX: "initial", maxWidth: "100% !important" }}
    >
      <Table
        disableColumnResize={true}
        stickyHeader
        className="table-auto min-w-[95vh] w-full pb-24"
      >
        <TableHead className="text-left border-gray border-b-2 sticky z-[50]">
          <TableCell className="table-cell-title font-normal pl-[16px] pb-[10px]">
            Id
          </TableCell>
          <TableCell className="table-cell-title font-normal pl-[16px] pb-[10px]">
            Active/Inactive
          </TableCell>{" "}
          <TableCell className="table-cell-title font-normal pl-[16px] pb-[10px]">
            Value
          </TableCell>{" "}
          <TableCell className="table-cell-title font-normal pl-[16px] pb-[10px]">
            Balance
          </TableCell>{" "}
          <TableCell className="table-cell-title font-normal pl-[16px] pb-[10px]">
            Code
          </TableCell>{" "}
          <TableCell className="table-cell-title font-normal pl-[16px] pb-[10px]"></TableCell>
          <TableCell className="table-cell-title"></TableCell>
        </TableHead>
        <TableBody>
          {giftcards.map((giftcard) => (
            <GiftcardRow giftcard={giftcard} refresh={() => refresh()} store={store} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
